module.exports = __webpack_public_path__ + "static/media/22ESCWA21.b24460bf.jpg";